import { themeConfig } from '@themeConfig'

export const resolveVuetifyTheme = () => {
  const storedTheme = localStorage.getItem(`${themeConfig.app.title}-theme`) || themeConfig.app.theme.value

  return storedTheme === 'system'
    ? 'light' // Always return 'light' when dark mode is preferred
    : storedTheme
}
